module.exports = __webpack_public_path__ + "static/media/iphone_11_green.47cb4daf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/custom-products/iphone/iphone_11_green.png
// module id = 2067
// module chunks = 0